const BLOCKED_TAGS = ['script', 'style', 'iframe', 'object', 'embed', 'link', 'meta', 'form', 'input', 'button'];

/**
 * Sanitização para pré-visualização do HTML gerado pelo editor:
 * remove tags executáveis, atributos de evento e links javascript:.
 */
export function sanitizeHtml(html?: string): string {
    if (!html) return '';
    const doc = new DOMParser().parseFromString(html, 'text/html');

    BLOCKED_TAGS.forEach((tag) => doc.querySelectorAll(tag).forEach((el) => el.remove()));

    doc.body.querySelectorAll('*').forEach((el) => {
        Array.from(el.attributes).forEach((attr) => {
            const name = attr.name.toLowerCase();
            const value = attr.value.trim().toLowerCase();
            if (name.startsWith('on')) el.removeAttribute(attr.name);
            if ((name === 'href' || name === 'src') && /^javascript:/.test(value)) el.removeAttribute(attr.name);
        });
    });

    return doc.body.innerHTML;
}

export function extractYoutubeId(url?: string): string | undefined {
    const match = url?.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/)|youtube-nocookie\.com\/embed\/|youtu\.be\/)([A-Za-z0-9_-]{11})/i);
    return match?.[1];
}

// Texto puro do HTML do editor, para pré-visualização em listas
export function htmlToPlainText(html?: string): string {
    if (!html) return '';
    const doc = new DOMParser().parseFromString(html.replace(/<\/(p|h[1-6]|li|blockquote)>/gi, '$& '), 'text/html');
    return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
}
